// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalContentList_proxy_container__CP\\+km {
  width: 100%;
  border: 1px solid var(--sb-border-color);
  border-bottom: none;
  padding: 21px 23px;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_option__YjIuS {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 23px;
  margin-bottom: 15px;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_option__YjIuS span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  margin-left: 10px;
  margin-right: auto;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_option__YjIuS button {
  line-height: 16px !important;
}
@media screen and (max-width: 781px) {
  .modalContentList_proxy_container__CP\\+km .modalContentList_proxy_option__YjIuS button {
    width: 100% !important;
    right: 0;
    margin-top: 17px;
    margin-left: 0 !important;
    text-align: center !important;
  }
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_option__YjIuS button svg {
  top: 35%;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_option__YjIuS button:last-child {
  margin-left: 9px;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_option__YjIuS button:last-child svg {
  top: 13%;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 422px;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd .modalContentList_proxy__jaVuR {
  width: 100%;
  height: 38px;
  border: 1px solid var(--re-border-color);
  border-radius: 10px;
  display: flex;
  margin-bottom: 10px;
  padding: 8px 16px;
}
@media screen and (max-width: 781px) {
  .modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd .modalContentList_proxy__jaVuR {
    overflow-x: auto;
    position: relative;
  }
  .modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd .modalContentList_proxy__jaVuR .modalContentList_copy_icon__m5YMM {
    position: absolute !important;
    top: 10px;
    left: 5px;
  }
  .modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd .modalContentList_proxy__jaVuR span {
    margin-left: 15px;
  }
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd .modalContentList_proxy__jaVuR .modalContentList_copy_icon__m5YMM {
  position: relative;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd .modalContentList_proxy__jaVuR span {
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-right: auto;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd .modalContentList_proxy__jaVuR img {
  cursor: pointer;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd::-webkit-scrollbar {
  width: 2px;
  height: 7px;
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd::-webkit-scrollbar-thumb {
  background: linear-gradient(316deg, #FFA329 4.43%, #FE7B1C 56.59%, #FC2A01 150.36%);
}
.modalContentList_proxy_container__CP\\+km .modalContentList_proxy_list__jadLd::-webkit-scrollbar-track {
  background-color: var(--bg-color);
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/modalContentList/modalContentList.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,wCAAA;EAEA,mBAAA;EACA,kBAAA;AAAJ;AAEI;EACI,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AAEQ;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAAZ;AAGQ;EACI,4BAAA;AADZ;AAGY;EAHJ;IAIQ,sBAAA;IACA,QAAA;IACA,gBAAA;IACA,yBAAA;IACA,6BAAA;EAAd;AACF;AAEY;EACI,QAAA;AAAhB;AAIQ;EACI,gBAAA;AAFZ;AAIY;EACI,QAAA;AAFhB;AAOI;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;AALR;AAOQ;EACI,WAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AALZ;AAOY;EATJ;IAUQ,gBAAA;IACA,kBAAA;EAJd;EAMc;IACI,6BAAA;IACA,SAAA;IACA,SAAA;EAJlB;EAOc;IACI,iBAAA;EALlB;AACF;AAQY;EACI,kBAAA;AANhB;AASY;EACI,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAPhB;AAUY;EACI,eAAA;AARhB;AAaI;EACI,UAAA;EACA,WAAA;AAXR;AAcI;EACI,mFAAA;AAZR;AAeI;EACI,iCAAA;AAbR","sourcesContent":[".proxy_container {\n    width: 100%;\n    border: 1px solid var(--sb-border-color);\n    // border-top: none;\n    border-bottom: none;\n    padding: 21px 23px;\n\n    .proxy_option {\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        margin-top: 23px;\n        margin-bottom: 15px;\n\n        span {\n            color: var(--font-color);\n            font-family: Red Hat Display;\n            font-size: 20px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 36px;\n            margin-left: 10px;\n            margin-right: auto;\n        }\n\n        button {\n            line-height: 16px !important;\n\n            @media screen and (max-width: 781px) {\n                width: 100% !important;\n                right: 0;\n                margin-top: 17px;\n                margin-left: 0 !important;\n                text-align: center !important;\n            }\n\n            svg {\n                top: 35%;\n            }\n        }\n\n        button:last-child {\n            margin-left: 9px;\n\n            svg {\n                top: 13%;\n            }\n        }\n    }\n\n    .proxy_list {\n        overflow-y: auto;\n        overflow-x: hidden;\n        max-height: 422px;\n\n        .proxy {\n            width: 100%;\n            height: 38px;\n            border: 1px solid var(--re-border-color);\n            border-radius: 10px;\n            display: flex;\n            margin-bottom: 10px;\n            padding: 8px 16px;\n\n            @media screen and (max-width: 781px) {\n                overflow-x: auto;\n                position: relative;\n\n                .copy_icon {\n                    position: absolute !important;\n                    top: 10px;\n                    left: 5px;\n                }\n\n                span {\n                    margin-left: 15px;\n                }\n            }\n\n            .copy_icon {\n                position: relative;\n            }\n\n            span {\n                color: var(--font-dark-color);\n                font-family: Red Hat Display;\n                font-size: 16px;\n                font-style: normal;\n                font-weight: 600;\n                line-height: normal;\n                margin-right: auto;\n            }\n\n            img {\n                cursor: pointer;\n            }\n        }\n    }\n\n    .proxy_list::-webkit-scrollbar {\n        width: 2px;\n        height: 7px;\n    }\n\n    .proxy_list::-webkit-scrollbar-thumb {\n        background: linear-gradient(316deg, #FFA329 4.43%, #FE7B1C 56.59%, #FC2A01 150.36%);\n    }\n\n    .proxy_list::-webkit-scrollbar-track {\n        background-color: var(--bg-color);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"proxy_container": `modalContentList_proxy_container__CP+km`,
	"proxy_option": `modalContentList_proxy_option__YjIuS`,
	"proxy_list": `modalContentList_proxy_list__jadLd`,
	"proxy": `modalContentList_proxy__jaVuR`,
	"copy_icon": `modalContentList_copy_icon__m5YMM`
};
export default ___CSS_LOADER_EXPORT___;
